import styled from '@nykaa/ui-components/styles/styled';
import { BREAKPOINTS } from 'shared/styles/base';
import ImageV2 from 'shared/components/ImageV2';

export const SavingsBanner = styled.div`
  display: flex;
  align-items: center;
  ${({ theme }) => `
    border-radius: ${theme.borders.radius40};
  `};
  position: relative;
`;

export const SavingsContent = styled.div<{ isLoggedInUser: boolean }>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  width: 50%;
  ${({ theme, isLoggedInUser }) => `
    bottom: ${isLoggedInUser ? theme.spacing.spacing120 : theme.spacing.spacing160};
    left: ${theme.spacing.spacing80};
  `};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme, isLoggedInUser }) => `
      width: 50%;
      // bottom: ${isLoggedInUser ? theme.spacing.spacing100 : theme.spacing.spacing120};
    `};
  }
`;

export const SavingsTextTitle = styled.div`
${({ theme }) => theme.typography.subTitleSmall};
  width: 100%;
  ${({ theme }) => `
    color: ${theme.colors.primary};
  `};  
`;

export const SavingsTextDesc = styled.div`
  ${({ theme }) => theme.typography.bodyMedium};
  ${({ theme }) => `
    color: ${theme.colors.primary};
  `};  
`;

export const SavingSpanTitle = styled.span`
  ${({ theme }) => theme.typography.buttonSmall};
  ${({ theme }) => `
    color: ${theme.colors.positive};
  `};  

`;
export const SavingsImage = styled(ImageV2)`
  margin-bottom: -1px;
  ${({ theme }) => `
    border-radius: ${theme.borders.radius40} ${theme.borders.radius40} 0 0;
  `};
  min-height: 130px;
  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
      min-height: 100px;
  }
`;

export const CloseIconWrapper = styled.div`
  position: absolute;
  ${({ theme }) => `
    top: ${theme.spacing.spacing40};
    left: ${theme.spacing.spacing40};  
  `}; 
  cursor: pointer;
  z-index: 2;
`;
